import { FirebaseDataService } from "../../../../services/firebase-data.service";

const firebaseDataService = new FirebaseDataService();

export function fetchGraphUTMOverall(statsObj, user, graph) {
  console.log("UTMOverall statsObj", statsObj)
  return new Promise(async (resolve, reject) => {
    try {
      firebaseDataService.graphUTMOverall(statsObj,user,graph, "firstLastTouch").subscribe((data) => {
        resolve({ data });
      });
    } catch (error) {
      reject(error);
    }
  });
}
